
import { Box } from '@mui/material';
import { useIsAuthenticated } from "@azure/msal-react";
import { Navigate, useLocation } from "react-router-dom";

// import { SignInButton } from "../../auth/SignInButton";
import { SignUpSignInButton } from '../../auth/SignUpSignInButton';

function Login() {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirectPath = searchParams.get('redirect');

  // console.log('LOGIN COMPONENT redirectPath, isAuthenticated', redirectPath, isAuthenticated);

  return (
    <Box className="Page Login">
      <h2 className="np-title">Login Page</h2>
      <Box sx={{m: 10, textAlign: 'center'}}>
        {
          isAuthenticated
          ?
            (
              redirectPath
              ?
              <Navigate to={redirectPath} replace />
              :
              <p>All good, you are logged in already.</p>
            )
          :
            <SignUpSignInButton label="Go On Then, Log In"></SignUpSignInButton>
        }
      </Box>
    </Box>
  );
}


export default Login;
